module.exports = __webpack_public_path__ + "static/media/workingmemory-numbers-7.1517108c.mp3";